export default function FormatFilterQuery(filterArray) {
	let query = '';

	filterArray.length !== 0 && filterArray.forEach(filter => {
		query += (filter.value !== '' ? '&' + filter.key + '=' + filter.value : '');
	});

	return query;
}